import React, { useState, useEffect, useContext, Fragment } from 'react';
import Layout from 'components/sales/layout/layout';
import localization from 'assets/localization/localization';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import { useParams } from 'react-router-dom';
import 'react-times/css/classic/default.css';
import Images from 'assets/images/imageData';
import "./assesment.css";
import TableSection from 'components/sales/tableSection/tableSection';

const styles = {
    fontFamily: "sans-serif",
    width: "500px",
  
    border: "1px solid #eee",
    background: "#f3f3f3",
    padding: "25px",
    margin: "20px"
  };
  

const Training = ({
    match,
    history,
    getLevelsByRole,
    roleLevels
}) => { 
    const { id } = useParams();
    const { baseUrl } = useContext(BaseUrl);
    const [isLoading, setIsLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const [listData, setListData] = useState();
    const [roleId, setRoleId] = useState();

    const headers = [
      'Level',
      'Score',
      'Status',
      'Action'
    ];

    useEffect(() => {
      const tableData = [
          'level',
          'marks_percentage',
          'isCleared',
      ];
      //console.log(roleLevels);
      if (roleLevels && roleLevels?.data && roleLevels?.data.length > 0) {
          const data = roleLevels.data.map((element) =>
              Object.assign(
                  {},
                  ...tableData.map((key) => (
                    (key === 'isCleared' && element['isCleared'] === 0) ? 
                    {[key]: 'Not Cleared'} : (key === 'isCleared' && element['isCleared'] === 1) ? 
                    {[key]: 'Cleared'}
                    :{ [key]: element[key] })
                  ),
                  element.show_test === 1 ?
                  {
                    Action: [
                      {
                        name: 'Assessment Resources',
                        link: `${baseUrl}/assesment-resources/${element.id}/${roleId}`,
                      },
                      {
                        name: 'Start Test',
                        link: `${baseUrl}/start-level-test/${element.id}/${roleId}`,
                      },
                      {
                        name: 'Results',
                        link: `${baseUrl}/assesment-history/${element.id}/${roleId}`,
                      }
                    ]
                  } : {
                    Action: [
                      {
                        name: 'Assessment Resources',
                        link: `${baseUrl}/assesment-resources/${element.id}/${roleId}`,
                      },
                      {
                        name: 'Results',
                        link: `${baseUrl}/assesment-history/${element.id}/${roleId}`,
                      }
                      
                    ]
                  }
              )
          );  
          data && setListData(data);
          setPageCount(Math.ceil(roleLevels.total / roleLevels.per_page));
      }
    }, [roleLevels]);

    console.log('PAGE::TRANING');
    
    useEffect(() => {
      setTimeout(() => {
        setIsLoading(true);
        (async () => {
          if(localStorage.getItem('roles')){
            const roles = await JSON.parse(localStorage.getItem('roles'))[0].id;
            setRoleId(roles);
          }
         
        })();
        setIsLoading(false);
      }, 1000);
    }, []);

    useEffect(() => {
       if(getLevelsByRole !== undefined && roleId) {
        (async () => {
          setIsLoading(true);
          const res = await getLevelsByRole(roleId);
          if(res) {
            console.log(res);
          }
          setIsLoading(false);
        })();  
       }
    },[getLevelsByRole,roleId]);

    return(
        <Layout
          title={localization.levels}
          //isGoback
          isLoading={isLoading}
          linkFlag
        >
        <div className="container-fluid">
         <div className="card">
          <div className='card-header'>Training and Assessment Module</div>
          <div className="card-body">
          <TableSection
              data={listData}
              isId={false}
              isMngId={false}
              headers={headers}
              pageCount={pageCount}
              srNo={roleLevels?.data?.from}
          />
          </div>
         </div>
        </div> 
        </Layout>
    );

};
export default Training;